module.exports = __webpack_public_path__ + "img/hotel-alif-avenidas.f853fcf3.jpg";